// extracted by mini-css-extract-plugin
export default {"spoiler":"Spoiler_spoiler__7WqtI","active":"Spoiler_active__Tj9q-","spoilerContent":"Spoiler_spoilerContent__vAbMQ","spoilerTitle":"Spoiler_spoilerTitle__BvXpa"};